<i18n>
    {
    "fr": {
    "createProperty": "Conception",
    "numberBuildingLicence": "N° de PC (Permis de Construire)",
    "yearBuildingLicence": "Année PC ",
    "remmberSurface": "Rappel de la décomposition des surfaces ",
    "partialSurface": "Surface Parcelle (m²)",
    "activSurface": "Surface active (m²) ",
    "observation": "Observations ",
    "diffrenceTypeSurface": "Différents types de surfaces ",
    "topsoilInGround": "Espace vert en pleine terre (m²)",
    "topsoilInSlab": "Terre végétale sur dalle &lt; 40 cm d'épaisseur (m²)",
    "simpleRoof" : "Toiture imperméable (m²)",
    "gravelledTerraceRoof": "Toiture gravillonnée (m²)",
    "otherSurfaceType": "Voiries, allées, parkings,… imperméables (m²)",
    "disconnectionWaterRain": "Déconnexion des eaux pluviales",
    "flow": "Débit",
    "disconnectionWaterRainNan" : "Aucun",
    "disconnectionTotalRainWater": "Déconnexion totale des eaux pluviales jusqu'à la pluie décennale prescrit",
    "disconnectionPartialRainWater": "Déconnexion partielle des eaux pluviales jusqu'à la pluie décennale prescrit",
    "disconnectionSurface": "Surface déconnectée (en m²) ",
    "leakFlow": "Débit de fuite prescrit (en L/s) ",
    "rateVolume": "Volume prescrit (m³) ",
    "disconnectionSurface": "Surface déconnectée jusqu'à la pluie décennale (m²)",
    "folderNumberOfConnection": "Numéro dossier branchement neuf",
    "newBuildingPermit": "Nouveau permis de construire",
    "subsidizedWork": "Ouvrage subventionné",
    "zac": "ZAC",
    "roadConstruction": "Ouvrage de voirie",
    "compliance" : "Mise en conformité",
    "originFolder": "Origine du dossier ",
    "typeOfWork": "Type",
    "controlOfWork": "Régulation",
    "number": "Nombre",
    "activeSurface": "Surface active raccordée à l'ouvrage",
    "surface": "Surface raccordée à l'ouvrage",
    "debit": "Débit prescrit",
    "volume": "Volume prescrit",
    "addWork": "Ajouter un ouvrage",
    "work": "Ouvrage - N°{number}",
    "chooseDecoEauPluv": "Choisissez un option",
    "extensiveGreenRoofThick": "Toiture végétalisée extensive (5-15 cm d'épaisseur) (m²)",
    "semiIntensiveGreenRoofThick": "Toiture végétalisée semi-intensive (15-40 cm d'épaisseur) (m²)",
    "intensiveRoofingThick": "Toiture intensive (40 cm à 1m d'épaisseur) (m²)",
    "semiPermeableCoating": "Revêtement semi-perméable (m²)",
    "disconnectionWaterPrescrite": "Déconnexion des eaux pluviales prescrite :",
    "topsoilOnSlabThickness": "Terre végétale sur dalle > 40 cm d'épaisseur (m²)",
    "areaNotCollectedOrSelfManaged": "Surface non collectée ou auto-gérée (espace pleine terre ; substrat > 80 cm d'épaisseur ou toiture régulée) (m²)",
    "estimatedNumberOfResident":"Estimation du nombre d’équivalent habitant ",
    "disconnectionWaterPrescrite":"Déconnexion des eaux pluviales prescrite jusqu'à la pluie décennale"
    }
}
</i18n>

<template>
  <div>
    <div class="panel panel-info conception-forms">
      <div class="panel-heading" v-on:click="conceptionVisibilityToggle()">
        {{ $t('createProperty') }}
        <div class="pull-right" v-b-toggle.filesDropzoneConceptionColl variant="primary">
          <span v-show="conceptionVisibility">
            <i class="fa fa-chevron-up curs"></i>
          </span>
          <span v-show="!conceptionVisibility">
            <i class="fa fa-chevron-down curs"></i>
          </span>
        </div>
      </div>

      <div v-show="conceptionVisibility" class="panel-body">
        <Content :title="this.$i18n.t('originFolder')" :only="true">
          <span slot="main-text-1">
            <b-form-group :label="$t('folderNumberOfConnection')" label-cols="5" label-size="md"
              label-for="folderNumberOfConnection">
              <b-form-input id="folderNumberOfConnection" name="folderNumberOfConnection" type="text"
                :maxlength="$MAX_255" size="sm" class="form-control"
                v-model="propertyForm.conception.folderNumberOfConnection" />
            </b-form-group>
            <b-form-checkbox plain id="newBuildingPermit" name="newBuildingPermit"
              v-model="propertyForm.conception.newBuildingPermit" class="form-group row">{{ $t('newBuildingPermit') }}
            </b-form-checkbox>
            <b-form-checkbox plain id="subsidizedWork" name="subsidizedWork"
              v-model="propertyForm.conception.subsidizedWork" class="form-group row">{{ $t('subsidizedWork') }}
            </b-form-checkbox>
            <b-form-checkbox plain id="compliance" name="compliance" v-model="propertyForm.conception.compliance"
              class="form-group row">{{ $t('compliance') }}</b-form-checkbox>
            <b-form-checkbox plain id="zac" name="zac" v-model="propertyForm.conception.zac" class="form-group row">{{
            $t('zac')
            }}</b-form-checkbox>
            <b-form-checkbox plain id="roadConstruction" name="roadConstruction"
              v-model="propertyForm.conception.roadConstruction" class="form-group row">{{ $t('roadConstruction') }}
            </b-form-checkbox>
            <b-form-group :label="$t('numberBuildingLicence')" label-cols="5" label-size="md"
              label-for="numberBuldingPermit">
              <b-form-input id="numberBuldingPermit" name="numberBuldingPermit" type="text" :maxlength="$MAX_255"
                size="sm" class="form-control" v-model="propertyForm.conception.numberBuldingPermit" />
            </b-form-group>
            <b-form-group :label="$t('yearBuildingLicence')" label-cols="5" label-size="md"
              label-for="yearBulidingPermit">
              <b-form-input id="yearBulidingPermit" name="yearBulidingPermit" type="number" min="0" size="sm"
                class="form-control" v-model="propertyForm.conception.yearBulidingPermit" />
            </b-form-group>
          </span>
        </Content>
        <Content :title="this.$i18n.t('remmberSurface')" :only="true">
          <span slot="main-text-1">
            <b-form-group :label="$t('partialSurface')" label-cols="5" label-size="md" label-for="partialSurface">
              <b-form-input id="partialSurface" name="partialSurface" type="text" step=".01" min="0" size="sm"
                class="form-control" v-model="propertyForm.conception.plotSurface" v-decimalSperator />
            </b-form-group>

            <h4 class="h4-g">
              {{ $t('diffrenceTypeSurface') }}
              <span class="pull-right">Coefficient</span>
            </h4>

            <b-form-group :label="$t('otherSurfaceType')" label-cols="5" label-size="md" label-for="otherSurfaceType">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="otherSurfaceType" name="otherSurfaceType" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.otherSurfaceType" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefOtherSurfaceType" name="coefOtherSurfaceType" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefOtherSurfaceType" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('simpleRoof')" label-cols="5" label-size="md" label-for="simpleRoof">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="simpleRoof" name="simpleRoof" type="number" step="0.01" min="0.00" max="99999999.99"
                    size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.simpleRoof" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefSimpleRoof" name="coefSimpleRoof" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefSimpleRoof" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('gravelledTerraceRoof')" label-cols="5" label-size="md"
              label-for="gravelledTerraceRoof">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="gravelledTerraceRoof" name="gravelledTerraceRoof" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.gravelledTerraceRoof" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefGravelledTerraceRoof" name="coefGravelledTerraceRoof" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefGravelledTerraceRoof" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('extensiveGreenRoofThick')" label-cols="5" label-size="md"
              label-for="extensiveGreenRoofThick">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="extensiveGreenRoofThick" name="extensiveGreenRoofThick" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.extensiveGreenRoofThick" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefExtensiveGreenRoofThick" name="coefExtensiveGreenRoofThick" type="number"
                    step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.coefExtensiveGreenRoofThick"
                    v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('semiIntensiveGreenRoofThick')" label-cols="5" label-size="md"
              label-for="semiIntensiveGreenRoofThick">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="semiIntensiveGreenRoofThick" name="semiIntensiveGreenRoofThick" type="number"
                    step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.semiIntensiveGreenRoofThick"
                    v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefSemiIntensiveGreenRoofThick" name="coefSemiIntensiveGreenRoofThick"
                    type="number" step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.coefSemiIntensiveGreenRoofThick"
                    v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('intensiveRoofingThick')" label-cols="5" label-size="md"
              label-for="intensiveRoofingThick">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="intensiveRoofingThick" name="intensiveRoofingThick" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.intensiveRoofingThick" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefIntensiveRoofingThick" name="coefIntensiveRoofingThick" type="number"
                    step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.coefIntensiveRoofingThick"
                    v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('semiPermeableCoating')" label-cols="5" label-size="md"
              label-for="semiPermeableCoating">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="semiPermeableCoating" name="semiPermeableCoating" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.semiPermeableCoating" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefSemiPermeableCoating" name="coefSemiPermeableCoating" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefSemiPermeableCoating" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('topsoilInSlab')" label-cols="5" label-size="md" label-for="topsoilInSlab">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="topsoilInSlab" name="topsoilInSlab" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.topsoilInSlab" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefTopsoilInSlab" name="coefTopsoilInSlab" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefTopsoilInSlab" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('topsoilOnSlabThickness')" label-cols="5" label-size="md"
              label-for="topsoilOnSlabThickness">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="topsoilOnSlabThickness" name="topsoilOnSlabThickness" type="number" step="0.01"
                    min="0.00" max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.topsoilOnSlabThickness" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefTopsoilOnSlabThickness" name="coefTopsoilOnSlabThickness" type="number"
                    step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.coefTopsoilOnSlabThickness"
                    v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('topsoilInGround')" label-cols="5" label-size="md" label-for="topsoilInGround">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="topsoilInGround" name="topsoilInGround" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.topsoilInGround" v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefTopsoilInGround" name="coefTopsoilInGround" type="number" step="0.01" min="0.00"
                    max="99999999.99" size="sm" class="form-control" v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefTopsoilInGround" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('areaNotCollectedOrSelfManaged')" label-cols="5" label-size="md"
              label-for="areaNotCollectedOrSelfManaged">
              <div class="row p-0 m-0">
                <div class="col-10 p-0 m-0 p-19">
                  <b-form-input id="areaNotCollectedOrSelfManaged" name="areaNotCollectedOrSelfManaged" type="number"
                    step="0.01" min="0.00" size="sm" max="99999999.99" class="form-control"
                    v-on:blur="calculateActivSurface" v-model="propertyForm.conception.areaNotCollectedOrSelfManaged"
                    v-decimalSperator />
                </div>
                <div class="col-2 p-0 m-0">
                  <b-form-input id="coefAreaNotCollectedOrSelfManaged" name="coefAreaNotCollectedOrSelfManaged"
                    type="number" step="0.01" min="0.00" max="99999999.99" size="sm" class="form-control"
                    v-on:blur="calculateActivSurface"
                    v-model="propertyForm.conception.coefAreaNotCollectedOrSelfManaged" v-decimalSperator />
                </div>
              </div>
            </b-form-group>

            <b-form-group :label="$t('activSurface')" label-cols="5" label-size="md" label-for="activeSurface">
              <b-form-input id="activeSurface" name="activeSurface" type="number" step="0.01" min="0.00"
                max="99999999.99" size="sm" class="form-control" readonly
                v-model="propertyForm.conception.activeSurface" v-decimalSperator />
            </b-form-group>

            <b-form-group :label="$t('disconnectionSurface')" label-cols="5" label-size="md"
              label-for="disconnectionSurface">
              <b-form-input id="disconnectionSurface" name="disconnectionSurface" type="number" min="0.00"
                max="99999999.99" size="sm" class="form-control" v-model="propertyForm.conception.surfaceDisconnect" />
            </b-form-group>

            <b-form-group :label="$t('observation')" label-cols="5" label-for="observations">
              <b-form-textarea :maxlength="$MAX_2000" id="observations" name="observations" class="form-control"
                v-model="propertyForm.conception.observations" rows="3" max-rows="6" />
            </b-form-group>
            <b-form-group :label="$t('disconnectionWaterPrescrite')" label-cols="5"
              label-for="disconnectionOfRainwater">
              <b-form-select name="disconnectionOfRainwater" v-model="propertyForm.conception.disconnectionOfRainwater"
                size="sm" plain>
                <option v-for="contact in optionsdisconnectionOfRainwater" :key="contact.value" :value="contact.value">
                  {{ contact.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </span>
        </Content>

        <Content :title="this.$i18n.t('flow')" :only="true">
          <span slot="main-text-1">
            <b-form-group :label="$t('leakFlow')" label-cols="5" label-size="md" label-for="leakFlowRate">
              <b-form-input id="leakFlowRate" name="leakFlowRate" type="number" step="0.01" size="sm"
                class="form-control" v-model="propertyForm.conception.leakFlowRate" />
            </b-form-group>
            <b-form-group :label="$t('rateVolume')" label-cols="5" label-size="md" label-for="rateVolume">
              <b-form-input id="rateVolume" name="rateVolume" type="number" step="0.01" size="sm" class="form-control"
                v-model="propertyForm.conception.rateVolume" />
            </b-form-group>
          </span>
        </Content>
        <template v-if="propertyForm.conception">
          <div class="panel panel-info" v-for="(work, index) in propertyForm.conception.works" :key="index">
            <div class="panel-heading">
              {{ $t('work', { number: index + 1 }) }}
              <b-link class="pull-right" @click.stop="deleteWork(work)">X</b-link>
            </div>
            <div class="panel-body">
              <b-form-group :label="$t('typeOfWork')" label-cols="4" label-for="typeOfWork">
                <b-form-select name="typeOfWork" :options="optionsTypeOfWork" v-model="work.typeOfWork" />
              </b-form-group>
              <b-form-group :label="$t('controlOfWork')" label-cols="4" label-for="controlOfWork">
                <b-form-select name="controlOfWork" :options="optionsControlOfWork" v-model="work.controlOfWork" />
              </b-form-group>
              <b-form-group :label="$t('number')" label-cols="4" label-for="number">
                <b-form-input name="number" type="number" v-model="work.number" />
              </b-form-group>
              <b-form-group :label="$t('surface')" label-cols="4" label-for="surface">
                <b-form-input name="surface" type="number" step="0.01" v-model="work.surface" />
              </b-form-group>
              <b-form-group :label="$t('activeSurface')" label-cols="4" label-for="activeSurface">
                <b-form-input name="activeSurface" type="number" step="0.01" v-model="work.activeSurface" />
              </b-form-group>
              <b-form-group :label="$t('debit')" label-cols="4" label-for="debit">
                <b-form-input name="debit" type="number" step="0.01" v-model="work.debit" />
              </b-form-group>

              <b-form-group :label="$t('volume')" label-cols="4" label-for="volume">
                <b-form-input name="volume" type="number" step="0.01" v-model="work.volume" />
              </b-form-group>
            </div>
          </div>
        </template>
        <div class="pull-left" v-if="propertyForm.conception.works.length <= 4">
          <b-link class="btn btn btn-cta s-btn btn-secondary" @click.stop="addWork">
            <v-icon name="plus" class="nok" />
            {{ $t('addWork') }}
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from '../Content';

import { propertyFormConceptionFields } from '../../utils/propertyFormConceptionFields';

export default {
  Name: 'ConceptionFields',
  components: {
    Content,
  },
  props: {
    propertyForm: { required: true },
  },
  data: () => ({
    money: {
      decimal: ', ',
      thousands: ' ',
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    aucun: false,
    conceptionVisibility: false,
    optionsdisconnectionOfRainwater: [
      { text: 'Aucune', value: 'none' },
      {
        text: "Déconnexion totale",
        value: 'totalDisconnection',
      },
      {
        text: "Déconnexion partielle",
        value: 'partialDisconnection',
      },
    ],
    optionsControlOfWork: [
      { text: 'Pompes', value: '0' },
      { text: 'Vortex', value: '1' },
      { text: 'A flotteur', value: '3' },
      { text: 'Orifice / Plaque', value: '4' },
      { text: 'Crapaudines', value: '5' },
      { text: 'Infiltration', value: '6' },
    ],
    optionsTypeOfWork: [
      { text: 'Bassin enterré avec casiers', value: '0' },
      { text: "Bassin enterré en nid d'abeille", value: '1' },
      { text: 'Bassin enterré visitable', value: '2' },
      { text: 'Bassin ouvert en eau', value: '3' },
      { text: 'Bassin ouvert sec', value: '4' },
      { text: 'Canalisation surdimensionnée', value: '5' },
      { text: 'Cuve de réutilisation des eaux de pluies', value: '6' },
      { text: 'Noue Minérale', value: '7' },
      { text: 'Noue Végétalisée', value: '8' },
      { text: "Puits d'infiltration non visitable", value: '9' },
      { text: "Puits d'infiltration vide", value: '10' },
      { text: "Puits d'infiltration visitable", value: '11' },
      { text: 'Toiture terrasse minérale', value: '12' },
      { text: 'Toiture végétalisée extensive', value: '13' },
      { text: 'Toiture végétalisée intensive', value: '14' },
      { text: 'Toiture végétalisée semi-intensive', value: '15' },
      { text: 'Tranchée Drainante', value: '16' },
    ],
    propertyFormConceptionFields: propertyFormConceptionFields,
  }),
  methods: {
    conceptionVisibilityToggle: function () {
      this.conceptionVisibility = !this.conceptionVisibility;
    },
    addWork: function () {
      this.propertyForm.conception.works.push({
        typeOfWork: null,
        controlOfWork: null,
        number: null,
        activeSurface: null,
        surface: null,
        debit: null,
        volume: null,
      });
    },
    deleteWork: function (work) {
      this.propertyForm.conception.works.splice(this.propertyForm.conception.works.indexOf(work), 1);
    },
    calculateActivSurface() {
        let activeSurface = 0.0;
        const allowedFields = [
          'topsoilInGround',
          'topsoilInSlab',
          'simpleRoof',
          'gravelledTerraceRoof',
          'otherSurfaceType',
          'extensiveGreenRoofThick',
          'semiIntensiveGreenRoofThick',
          'intensiveRoofingThick',
          'semiPermeableCoating',
          'topsoilOnSlabThickness',
          'areaNotCollectedOrSelfManaged',
      ];

      for (const field in this.propertyFormConceptionFields) {
        if (!allowedFields.includes(field)) {
          continue;
        }

        const coefField = 'coef' + field.charAt(0).toUpperCase() + field.slice(1);
        activeSurface += (this.propertyForm.conception[field] || 0) * (this.propertyForm.conception[coefField] || 0);
      }

      this.propertyForm.conception.activeSurface = Math.round(activeSurface * 100) / 100;
    },
    initPropertyConceptionFields: function () {
      for (const field in this.propertyFormConceptionFields) {
        const coefField = 'coef' + field.charAt(0).toUpperCase() + field.slice(1);

        // Init conception fields
        if (!this.propertyForm.conception.hasOwnProperty(field)) {
          this.propertyForm.conception[field] = null;
        }

        // Init conception fields
        if (!this.propertyForm.conception.hasOwnProperty(coefField)) {
          this.propertyForm.conception[coefField] = null;
        }

        // Set conception coef to default
        if (this.propertyForm.conception[coefField] === null) {
          this.propertyForm.conception[coefField] = this.propertyFormConceptionFields[field].coef;
        }
      }
    },
  },
  created: function () {
    if (
      !this.propertyForm.conception.totalDisconnectionRainWater &&
      !this.propertyForm.conception.partialDisconnectionRainWater
    ) {
      this.aucun = true;
    }
  },
  mounted: function () {
    this.initPropertyConceptionFields();
  },
};
</script>
<style scoped>
.collapsed>.when-opened,
:not(.collapsed)>.when-closed {
  display: none;
}

.curs {
  cursor: pointer;
}
</style>
